import styled from "styled-components";
import { motion } from "framer-motion";

export const TopContainerP5 = styled.div`
  width: 100%;
  height: 80px;
  background-color: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  h1 {
    font-size: 18px;
    margin: 10px;
    font-weight: 500;
  }
`;

export const RefreshBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  right: 15px;
  top: 86px;
  z-index: 1000;
  .spin {
    animation: spin 3s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ContainerP5 = styled(motion.div)`
  width: 100%;
  height: calc(100dvh - 8dvh);
  position: relative;
  .linear-separation {
    background: linear-gradient(
      180deg,
      #c4c4c4 0%,
      rgba(196, 196, 196, 0) 100%
    );
    width: 100%;
    height: 4px;
    mix-blend-mode: multiply;
    opacity: 0.25;
  }
`;

export const BodyContainerP5 = styled.div`
  width: 100%;
  height: calc(100dvh - 182px);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  gap: 20px;
  padding: 10px 0 50px 0px;
  h1 {
    text-align: center;
  }
  z-index: 1;
  margin-top: 30px;
  /* Oculta la barra de scroll pero permite desplazamiento */
  -ms-overflow-style: none; /* IE y Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    /* Chrome, Safari y Opera */
    display: none;
  }

  /* Layout responsivo: en tablet y desktop usamos flex-wrap para disponer las
     tarjetas horizontalmente y centrar cada fila dinámicamente: 1, 2 o 3 por fila. */
  @media (min-width: 768px) and (max-width: 1199px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: center; /* centra cada línea con 1 o 2 items */
    align-content: flex-start;
    padding: 20px 20px 60px 20px;
    height: calc(100dvh - 182px);
    box-sizing: border-box;
    /* límite 2 columnas + padding: 2*330 + gap + 2*20 */
    max-width: calc(660px + 24px + 40px);
    margin: 30px auto 0 auto;
    overflow-y: auto;
  }

  @media (min-width: 1200px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 28px;
    justify-content: center; /* centra cada línea con 1, 2 o 3 items */
    align-content: flex-start;
    padding: 30px 40px 80px 40px;
    height: calc(100dvh - 182px);
    box-sizing: border-box;
    /* límite 3 columnas + padding: 3*330 + 2*gaps + 2*40 */
    max-width: calc(990px + 56px + 80px);
    margin: 30px auto 0 auto;
    overflow-y: auto;
  }
`;

export const ButtonP5 = styled.button`
  width: 100%;
  height: 39px;
  background: var(--color-primary);
  font-size: 16px;
  color: var(--color-white);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 10px;
`;

export const ContainerButton = styled.div`
  position: relative;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding-top: 10px;
  padding-bottom: 30px;
`;

export const ContainerSinTurno = styled.div`
  width: 100%;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 35px;
  margin-top: 81px;
  .title {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    width: 305px;
    text-align: center;
  }
  .subtitle {
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    width: 305px;
    text-align: center;
  }
`;

export const CardOrden = styled.div`
  width: 330px;
  height: auto;
  background: var(--color-white);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  text-align: left;
  /* border: 1px solid var(--color-black); */
  box-shadow: rgba(0, 0, 0, 0.05) 0px 41.7776px 33.4221px,
    rgba(0, 0, 0, 0.043) 0px 22.3363px 17.869px,
    rgba(0, 0, 0, 0.035) 0px 12.5216px 10.0172px,
    rgba(0, 0, 0, 0.027) 0px 6.6501px 5.32008px,
    rgba(0, 0, 0, 0.02) 0px 2.76726px 2.21381px;
  /* El card mantiene 330px para centrar correctamente con 1/2/3 items */
  .header {
    background-color: var(--color-latex30);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 18px;
    text-align: center;
  }
  .bodyOrden {
    display: flex;
    flex-direction: column;
    text-align: left;
    gap: 10px;
    padding: 20px 20px;
    width: 100%;
  }
  .btnOrdenPdf {
    display: flex;
    gap: 6px;
    margin: auto;
    /* height: 30px; */
    background: var(--color-white);
    color: var(--color-latex30);
    border: 2px solid var(--color-latex30);
    padding: 6px 8px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    cursor: pointer;
  }
`;
